import React, {useState, useEffect} from "react";
import axios from "axios";
import Background from "./background.js";
import Ready from "./ready.js";
import Title from "./title.js";
import WelcomePopup from "./WelcomePopup.js";

export default function Home() {
    const [render, setrender] = useState(false);
    const [bayday, setbayday] = useState({});
    const [showWelcome, setShowWelcome] = useState(false);

  useEffect(()=>{
    // Check if user has visited before
    const hasVisited = localStorage.getItem('ptb_visited');
    if (!hasVisited) {
      setShowWelcome(true);
    }
    
    axios
      .get(`https://ptb-api.vercel.app`)
      .then((res) => {
        setbayday(res.data);
        setrender(true);
      })
      .catch((err) => {
        console.log('Error from axios');
      });
  },[]);

  const handleCloseWelcome = () => {
    localStorage.setItem('ptb_visited', 'true');
    setShowWelcome(false);
  };

  return(
    <>
        {showWelcome && <WelcomePopup onClose={handleCloseWelcome} />}
        
        { render ? (
        <>
            {/* <Background/> */}
            <Title/>
            <Ready bayday={bayday} />
        </>) : (
        <>
            {/* <Background/> */}
            <Title/>
        </>
        )}
    </>
  )
}